import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepAddress: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>What’s your address?</StepTitle>
    <ApplicationField product={Product.Loan} field={Fields.AddressOne} onEnter={props.onEnter} />
    <ApplicationField product={Product.Loan} field={Fields.AddressTwo} onEnter={props.onEnter} />
    <ApplicationField product={Product.Loan} field={Fields.Zipcode} onEnter={props.onEnter} />
    <ApplicationField product={Product.Loan} field={Fields.City} onEnter={props.onEnter} />
    <ApplicationField product={Product.Loan} field={Fields.State} onEnter={props.onEnter} />
  </Wrapper>
)

export default StepbystepApplicationStepAddress
